




















































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import GeneralDocumentService, {
  GeneralDocument
} from "@/services/GeneralDocument";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { PanduanStoreModule } from "@/store/modules/PanduanStore";
//import UserList from "@/services/UserList";

interface GeneralDocumentForm {
  id: number | null;
  judul: string;
  keterangan: string;
  file: File | null;
  link: string | null;
  fileName: string;
  aktif: boolean | string;
}

@Component({
  beforeRouteEnter(to, from, next) {
    if (userModule.hasPrivilege("master_general_document", "view")) {
      next();
    } else {
      appModule.sendErrorAlert("Halaman ini tidak bisa diakses...");
      next("/404");
    }
  }
})
export default class GeneralDocumentPage extends Vue {
  allGeneralDocumentData: GeneralDocument[] = []; //=dataList
  dataList: GeneralDocument[] = [];
  loading = true;
  searchStr: string | null = null; //=searchPx
  dialog = false;
  isEdit = false;
  file: File | null;
  dataAwalForm: GeneralDocumentForm | null = null;
  existingFileName: string | null = null;
  fileServerPath?: string | null;
  //aktif = true;
  //usersMap = {};

  inputType: "file" | "link" = "file";
  dataAwalInputType: "file" | "link" = "file";

  mounted() {
    appModule.setLoading(true);
    this.getDataGeneralDocument();
  }

  form: GeneralDocumentForm = {
    id: null,
    judul: "",
    keterangan: "",
    file: null,
    link: null,
    fileName: "",
    aktif: "1"
  };

  //options = {};

  get listItems() {
    //return this.filteredGeneralDocumentData.map((item, i) => ({
    return this.dataList.map((item, i) => ({
      ...item,
      no: i + 1,
      tgl: moment(item.created_at).format("DD MMMM YYYY HH:mm")
      //user: this.getUserName(item.user)
    }));
  }

  // get listItemsTotal() {
  //   return this.dataList.length;
  // }

  // getResetedDataGeneralDocument() {
  //   this.searchStr = null;
  //   this.pencarianData();
  // }

  get headers() {
    return [
      { text: "No", value: "no" },
      { text: "Judul Dokumen", value: "judul" },
      //{ text: "Kategori", value: "kategori" },
      { text: "Keterangan", value: "keterangan" },
      { text: "Dokumen General", value: "dokumen" },
      { text: "Tanggal Upload", value: "tgl" },
      { text: "User Upload", value: "user" },
      { text: "Status", value: "aktif" },
      { text: "Aksi", value: "aksi", sortable: false }
    ];
  }

  created() {
    this.getDataGeneralDocument();
  }

  getDataGeneralDocument() {
    this.loading = true;
    GeneralDocumentService.getGeneralDocumentList({
      search: ""
    })
      .then(resp => {
        this.allGeneralDocumentData = resp;
        this.pencarianData();
      })
      .catch(() => (this.allGeneralDocumentData = []))
      .finally(() => (this.loading = false));
  }

  get dokumenBerubah(): boolean {
    if (!this.isEdit || !this.dataAwalForm) return true;

    const dataAwal = this.dataAwalForm;
    const dataBaru = this.form;

    // Deteksi pergantian tipe input
    if (this.inputType !== this.dataAwalInputType) return true;

    // Pengecekan per tipe input
    if (this.inputType === "file" && dataBaru.file instanceof File) return true;
    if (this.inputType === "link" && dataBaru.link !== dataAwal.link)
      return true;

    return (
      dataAwal.judul !== dataBaru.judul ||
      dataAwal.keterangan !== dataBaru.keterangan ||
      String(dataAwal.aktif) !== String(dataBaru.aktif)
    );
  }

  tambahGeneralDocument() {
    this.isEdit = false;
    this.dialog = true;
    this.inputType = "file";
    this.file = null;
    this.existingFileName = null;
    this.form = {
      id: null,
      judul: "",
      keterangan: "",
      file: null,
      link: null,
      aktif: "1",
      fileName: ""
    };
  }

  editGeneralDocument(item: GeneralDocumentForm) {
    this.isEdit = true;
    this.dialog = true;
    this.file = null;

    if (item.link && item.link.trim() !== "") {
      this.inputType = "link";
      this.existingFileName = item.link;
    } else {
      this.inputType = "file";
      this.existingFileName = item.file ? this.getFileName(item.file) : null;
    }

    this.dataAwalInputType = this.inputType;

    this.form = {
      ...item,
      file: item.file,
      link: item.link || "",
      aktif: item.aktif === true || String(item.aktif) === "1",
      fileName: item.fileName
    };
    //const fileServerPath = (item.file as unknown) as string | null | undefined;

    // Pastikan hanya memanggil getFileName jika fileServerPath adalah string
    // this.existingFileName =
    //   fileServerPath && typeof fileServerPath === "string"
    //     ? this.getFileName(fileServerPath)
    //     : null;
    this.dataAwalForm = { ...this.form };
  }

  closeDialog() {
    this.dialog = false;
    // reset form
    this.form = {
      id: null,
      judul: "",
      keterangan: "",
      file: null,
      link: null,
      fileName: "",
      aktif: true
    };

    // reset input file model
    this.file = null;
    this.inputType = "file";
  }

  saveForm() {
    const formData = new FormData();
    formData.append("judul", this.form.judul);
    formData.append("keterangan", this.form.keterangan);

    // ambil langsung dari toggle form.aktif
    formData.append("aktif", this.form.aktif ? "1" : "0");

    // Tangani slot file dan link berdasarkan Tipe Input yang dipilih
    if (this.inputType === "link") {
      formData.append("link", this.form.link || "");
      formData.append("file", "");
    } else if (this.inputType === "file") {
      formData.append("link", "");
      if (this.form.file instanceof File) {
        formData.append("file", this.form.file);
      }
    }

    formData.append("tgl", new Date().toISOString());
    this.loading = true;

    if (this.isEdit) {
      formData.append("_method", "PUT");
      GeneralDocumentService.updateGeneralDocument(this.form.id, formData)
        .then(() => {
          //this.$root.$emit("GeneralDocument-updated");
          PanduanStoreModule.fetchPanduan();
          appModule.sendSuccessNotice("General Document berhasil diperbarui");
          this.closeDialog();
          this.getDataGeneralDocument();
        })
        .finally(() => (this.loading = false));
    } else {
      GeneralDocumentService.createGeneralDocument(formData)
        .then(() => {
          //this.$root.$emit("GeneralDocument-updated");
          PanduanStoreModule.fetchPanduan();
          appModule.sendSuccessNotice("General Document berhasil ditambahkan");
          this.closeDialog();
          this.getDataGeneralDocument();
        })
        .finally(() => (this.loading = false));
    }
  }

  async deleteGeneralDocument(item: GeneralDocumentForm) {
    if (!confirm("Yakin hapus General Document ini?")) return;

    this.loading = true;

    GeneralDocumentService.deleteGeneralDocument(item.id)
      .then(() => {
        this.$root.$emit("GeneralDocument-updated");
        appModule.sendSuccessNotice("General Document berhasil dihapus");
        this.getDataGeneralDocument();
      })
      .catch(() => {
        appModule.sendErrorAlert("Gagal menghapus General Document");
      })
      .finally(() => (this.loading = false));
  }

  onFileChange(file: File | null) {
    if (!file) {
      this.form.file = null;
      //this.form.fileName = "";
      this.file = null;
      return;
    }
    this.form.file = file;
    //this.form.fileName = file.name;
  }

  get currentFileStatus(): { status: string; name: string } | null {
    // if (this.form.file instanceof File) {
    //   return {
    //     status: "Baru Dipilih",
    //     name: this.form.file.name
    //   };
    // }
    if (this.isEdit && this.existingFileName) {
      return {
        status:
          this.dataAwalInputType === "link"
            ? "Link tersimpan: "
            : "File tersimpan: ",
        name: this.existingFileName
      };
    }

    return null;
  }

  //pencarian di frontend
  pencarianData() {
    this.loading = true;

    if (!this.searchStr || this.searchStr.trim() === "") {
      this.dataList = this.allGeneralDocumentData;
      this.loading = false;
      return;
    }

    const search = this.searchStr.toLowerCase();

    const hasilPencarian = this.allGeneralDocumentData.filter(item => {
      const cariJudul = item.judul
        ? item.judul.toLowerCase().includes(search)
        : false;
      const cariKeterangan = item.keterangan
        ? item.keterangan.toLowerCase().includes(search)
        : false;
      const cariFile = item.file
        ? item.file.toLowerCase().includes(search)
        : false;
      const cariLink = item.link
        ? item.link.toLowerCase().includes(search)
        : false;
      const tglStr = moment(item.created_at)
        .format("DD MMMM YYYY HH:mm")
        .toLowerCase();
      const cariTgl = tglStr.includes(search);
      const cariUser = item.user
        ? item.user.toLowerCase().includes(search)
        : false;

      return (
        cariJudul ||
        cariKeterangan ||
        cariFile ||
        cariTgl ||
        cariUser ||
        cariLink
      );
    });
    this.dataList = hasilPencarian;
    this.loading = false;
  }

  onRowClick(item: GeneralDocumentForm) {
    console.log("klik baris", item);
  }

  previewDialog = false;
  previewUrl: string | null = null;

  openPreview(fileUrl) {
    if (!fileUrl) return;

    let url = fileUrl;
    if (!/^https?:\/\//i.test(fileUrl)) {
      url = `${window.location.origin}/${fileUrl.replace(/^\/+/, "")}`;
    }
    //console.log("Opening:", url);

    const ext = url
      .split(".")
      .pop()
      ?.toLowerCase();

    if (ext === "pdf") {
      const newTab = window.open(url, "_blank", "noopener,noreferrer");
      if (!newTab) {
        alert("Izinkan pop-up di browser agar file bisa terbuka di tab baru.");
      }
    } else {
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop() || "file";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  closePreview() {
    this.previewDialog = false;
    this.previewUrl = null;
  }

  getFileName(path: string | File | null | undefined): string {
    if (!path) {
      return "";
    }
    if (path instanceof File) {
      return path.name;
    }
    if (typeof path !== "string") {
      return "";
    }
    // ambil bagian setelah '/' terakhir
    return path.split("/").pop() || path;
  }

  get isSavedButtonDisabled(): boolean {
    const isFormInvalid =
      !this.form.judul ||
      (this.inputType === "link" && !this.form.link) ||
      (this.inputType === "file" && !this.isEdit && !this.form.file);

    const isEditNoCange = this.isEdit && !this.dokumenBerubah;

    return isFormInvalid || isEditNoCange;
  }

  // async loadUsers() {
  //   try {
  //     const res = await UserList.getAll();

  //     // buat map user: { id: name }
  //     this.usersMap = Object.fromEntries(res.data.map(u => [u.id, u.name]));
  //   } catch (err) {
  //     console.error(err);
  //   }
  // }

  // getUserName(id) {
  //   return this.usersMap[id] || "-";
  // }
}
